import { initMediaWithThumbnailCarousels } from './modal-gallery-v2';

/**
 * This class is used with plans and inventory home listing widget
 */
class CardListing {

    /**
     * @param endPoint Endpoint used to post user action click for View All button
     * @param moduleSelector jQuery selector 
     */
    constructor(endPoint, moduleSelector, pageSize) {
        this.endPoint = endPoint;
        this.moduleElem = $(moduleSelector);
        this.viewMoreButtonElem = this.moduleElem.find("#view_more_btn");
        this.pageCounter = 1;
        this.pageSize = pageSize;
    }

    /**
     * Get request to fetch the data for CardListing 
     * @returns Promise
     */
    getCardListing() {
        let _this = this;
        return new Promise(function (resolve, reject) {
            try {
                // Get Anti-CSRF token
                let csrfToken = _this.moduleElem.find('[name="__RequestVerificationToken"]').val();
                let endpointUrl = _this.endPoint;
                let contentPath = _this.moduleElem.find("#cards-contentpath").val();
                //When plan page it's required current page url so that we do not have repeated items 
                let pageContentPath = _this.moduleElem.find("#cards-nodealiaspath").val();
                let pageSize = _this.pageSize;
                let data = { contentPath: contentPath, pageSize: pageSize, pageContentPath :pageContentPath };
                $.ajax({
                    type: "GET",
                    url: endpointUrl,
                    data: data,
                    cache: false,
                    dataType: "html",
                    beforeSend: function (request) {
                        if (csrfToken) {
                            request.setRequestHeader("__RequestVerificationToken", csrfToken);
                        }
                        window.showPreLoader();
                    },
                    success: function (response) {
                        if ((response != null)) {
                            if (resolve) resolve(response);
                            // Append the HTML code to a div element with the given ID
                            let cardContainer = _this.moduleElem.find("#cards-container");
                            cardContainer.append(response);

                            _this.viewMoreButtonElem.remove();
                            // in case it exists remove the entire wrapper which may included "3 more Quick Move In Homes available at XXX...";
                            let viewMoreWrapperElem = _this.moduleElem.find(".view-more-wrapper");
                            if ( viewMoreWrapperElem ) {
                                viewMoreWrapperElem.remove();
                            }
                            
                            // lazy load images
                            lozadObserver();
                            
                            //Initialize favorite button
                            initFavoriteButtons($(".card-like-button"));
                           
                            // re-init carousel binding right now before we reflow the reveal modals.
                            // reflow will process the newly inserted modals and therefore move them
                            // outside of its original placement to the root of the document, so therefore
                            // we need to execute this before to be able to target these new carousel modals
                            initMediaWithThumbnailCarousels(cardContainer[0]);

                            // re-init the reveal modal for image and video gallery
                            window.Foundation.reflow($(".media-modal"), 'reveal');

                            //Foundation initialization for the card carousel
                            window.foundationWrapper(cardContainer);


                            // Invoke foundation to reinitialize the equalizer plugin for this instance
                            // as new cards may have loaded into DOM with differing amounts of content.
                            // Recalculate by invoking reflow on module which is implicitly the same as
                            // calling 
                            //      window.Foundation.reflow($('[data-equalizer]'));
                            // specifically for this equalizer instance (since the module is an equalizer instance)
                            window.Foundation.reflow($(_this.moduleElem));

                            // for some reason, there is a race condition time wise when intitializing
                            // AJAX loaded tooltips here and thus we need to wait a second and use special 
                            // logic to reinit the tooltips including the newly loaded ones
                            setTimeout(() => {
                                let tooltips = cardContainer.find(".pricing-tooltip");
                                _this.reinitializeTooltips($(tooltips));
                            }, 1000)

                        }
                        else {
                            if (reject) reject(response);
                        }
                    },
                    error: function (request, textStatus, errorThrown) {
                        if (reject) reject("AJAX error: " + request.statusText);
                    }
                })
            }
            catch (err) {
                if (reject) reject("Error occurred fetching cards:" + err);
            }
        });
    }

    /**
     * Reinintialize tooltips by destorying theme and them reinitializing them
     * @param {*} tooltips jQuery Element pointing to tooltips ro reinit
     */
    reinitializeTooltips(tooltips) {
        window.foundationWrapper(tooltips, "_destroy");
        window.foundationWrapper(tooltips, "_init");
    }


    /**
     * Initialize the view more button instance 
     */
    init() {
        this.viewMoreButtonElem.on("click", (event) => this.onViewMoreButtonClick(event));
        let cardContainer = this.moduleElem.find("#cards-container")[0];

        // initialize the carousels in this card listing
        initMediaWithThumbnailCarousels(cardContainer);

        lozadObserver();
    }

    /**
     * Event Handler for click of view more plans button
     * @param {jQuery Event} e event object
     */
    onViewMoreButtonClick(e) {
        e.preventDefault();
        this.getCardListing().then((response) => {
            window.hidePreLoader();
        }).catch((error) => {
            console.error(error);
        }).finally(() => {
            window.hidePreLoader();
        });
    }
}

window.CardListing = CardListing;